__webpack_require__.p = "/Jewelry-project/";